import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import LinearProgress from "@mui/material/LinearProgress";


import SignUp from './components/SignUp';
import Centered from '../../components/Centered';
import Login from './components/Login';


interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}



const Auth = () => {
  const [value, setValue] = React.useState(0);
  const [loading, setLoading] = React.useState(false);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    if (loading) return;
    setValue(newValue);
  };

  // Color.fromRGBO(0x73, 0x80, 0xf3, 1),
  // Color.fromRGBO(0x56, 0x69, 0xff, 1),
  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  return (
    <Centered sx={{
      minHeight: '100vh',
      backgroundColor: 'rgb(115,128,243)',
      background: 'linear-gradient(90deg, rgba(115,128,243,1) 0%, rgba(86,105,255,1) 35%, rgba(54,122,255,1) 100%)',
      p: 3
    }}>

      <Card sx={{
        minWidth: 300,
        width: "90%",
        maxWidth: 400
      }}>
        {loading && <LinearProgress />}
        <Box sx={{
          borderBottom: 1, borderColor: 'divider', display: "flex",
          pt: 1,
          alignItems: "center",
          justifyContent: "center"
        }}>
          <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" sx={{

          }}>
            <Tab label="Log In" {...a11yProps(0)} />
            <Tab label="Sign Up" {...a11yProps(1)} />

          </Tabs>
        </Box >

        <TabPanel value={value} index={0}>
          <Login onLoading={setLoading} />

        </TabPanel>
        <TabPanel value={value} index={1}>
          <SignUp onLoading={setLoading} />
        </TabPanel>

      </Card>

    </Centered>
  )
}

export default Auth
